import { FETCH_AUTH, LOGOUT, SET_AUTH_USER } from '../actions/types';

export default (state = null, action) => {
  switch (action.type) {
    case FETCH_AUTH:
      return {
        ...state,
        isAuthenticated: true,
      };
    case LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
      };
    case SET_AUTH_USER:
      return {
        ...state,
        user: action.payload,
      };
    default:
      return state;
  }
};
